export let initialState = {
  account_settings: false
}

export const updateSettings = (account) => (updatedSettings) => {
  account.setState({ account_settings: updatedSettings })
}
